<template>
  <div class="comissoes-page">
    <b-overlay :show="loading" spinner-variant="primary" blur="0" opacity=".75" rounded="md">

      <nav class="breadcrumb-nav">
        <router-link :to="{ name: 'dashboard-ptc' }" class="breadcrumb-link">
          <feather-icon icon="HomeIcon" size="14" />
          <span>Home</span>
        </router-link>
        <feather-icon icon="ChevronRightIcon" size="14" class="breadcrumb-separator" />
        <span class="breadcrumb-current">Relatório de Comissões</span>
      </nav>

      <ActionBar
        :active-filters-count="activeFiltersCount"
        :filter-chips="filterChipsData"
        :is-loading="loading"
        :show-primary-action="false"
        @toggle-filters="openDrawer"
        @remove-chip="handleRemoveChip"
      >
        <template #actions>
          <button class="action-bar-btn primary-btn" :disabled="loading" @click="pesquisar">
            <feather-icon icon="SearchIcon" size="14" />
            <span class="btn-text">Pesquisar</span>
          </button>
          <button class="action-bar-btn ghost-btn" @click="limparFiltros">
            <feather-icon icon="XIcon" size="14" />
            <span class="btn-text">Limpar</span>
          </button>
          <button class="action-bar-btn secondary-btn" @click="gerarRelatorioPDF">
            <feather-icon icon="FileTextIcon" size="14" />
            <span class="btn-text">Gerar PDF</span>
          </button>
        </template>
      </ActionBar>

      <div class="kpi-row" v-if="dadosComissoes.length > 0">
        <div class="kpi-card">
          <div class="kpi-icon">
            <feather-icon icon="HashIcon" size="20" />
          </div>
          <div class="kpi-content">
            <span class="kpi-value">{{ meta.total || 0 }}</span>
            <span class="kpi-label">Registros</span>
          </div>
        </div>
        <div class="kpi-card">
          <div class="kpi-icon">
            <feather-icon icon="FileTextIcon" size="20" />
          </div>
          <div class="kpi-content">
            <span class="kpi-value" v-if="!loadingTotals">{{ totalVlNota | formatCurrency }}</span>
            <span class="kpi-value" v-else>...</span>
            <span class="kpi-label">Total VL Nota</span>
          </div>
        </div>
        <div class="kpi-card kpi-card-highlight">
          <div class="kpi-icon">
            <feather-icon icon="DollarSignIcon" size="20" />
          </div>
          <div class="kpi-content">
            <span class="kpi-value" v-if="!loadingTotals">{{ totalVlComissao | formatCurrency }}</span>
            <span class="kpi-value" v-else>...</span>
            <span class="kpi-label">Total Comissão</span>
          </div>
        </div>
      </div>

      <div class="content-card" v-if="dadosComissoes.length > 0">
        <div class="card-header">
          <h3 class="card-title">Notas Fiscais</h3>
          <div class="table-info">
            <span class="text-muted">{{ dadosComissoes.length }} de {{ meta.total }} registros</span>
          </div>
        </div>
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>Estab</th>
                <th>NR Documento</th>
                <th>Data</th>
                <th>Emitente</th>
                <th>Razão Social</th>
                <th>Marca</th>
                <th>Pedido</th>
                <!-- <th>Ocorrência</th> -->
                <th class="text-right">Porcentagem</th>
                <th class="text-right">VL Base</th>
                <th class="text-right">VL Comissão</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in dadosComissoes" :key="idx">
                <td class="font-mono">{{ item.cod_estab }}</td>
                <td class="font-mono">{{ item.esp_docto }} {{ item.nr_nota_docto }}</td>
                <td>{{ item.dt_emis | formatDate }}</td>
                <td class="font-mono">{{ item.clienteiderp }}</td>
                <td>{{ item.clienterazaosocial }}</td>
                <td>{{ item.des_marca }}</td>
                <td class="font-mono">{{ item.nro_ped_venda }}</td>
                <!-- <td class="font-mono">{{ item.nro_ocor }}</td> -->
                <td class="text-right">{{ parseFloat(item.perc_comis || 0).toFixed(2) }}%</td>
                <td class="text-right font-mono">{{ item.vl_nota | formatCurrency }}</td>
                <td class="text-right font-mono">{{ item.vl_comis | formatCurrency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-footer">
          <div class="per-page-control">
            <span class="per-page-label">Exibir</span>
            <select v-model="filtros.perPage" @change="changePage" class="per-page-select">
              <option v-for="opt in pageOptions" :key="opt" :value="opt">{{ opt }}</option>
            </select>
          </div>
          <div class="pagination-controls">
            <button class="page-btn" :disabled="filtros.page <= 1" @click="goToPage(filtros.page - 1)">
              <feather-icon icon="ChevronLeftIcon" size="16" />
            </button>
            <span class="page-info">{{ filtros.page }} / {{ meta.pages || 1 }}</span>
            <button class="page-btn" :disabled="filtros.page >= (meta.pages || 1)" @click="goToPage(filtros.page + 1)">
              <feather-icon icon="ChevronRightIcon" size="16" />
            </button>
          </div>
        </div>
      </div>

      <div class="empty-state" v-else-if="!loading">
        <feather-icon icon="AlertTriangleIcon" size="48" class="empty-icon" />
        <p class="empty-text">Nenhum resultado encontrado</p>
        <p class="empty-hint">Ajuste os filtros e clique em Pesquisar</p>
      </div>

      <div class="content-card" v-if="dadosResumoCalculado.length > 0">
        <div class="card-header">
          <h3 class="card-title">Resumo por Marca</h3>
        </div>
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>Marca</th>
                <th class="text-right">VL Comissão</th>
                <th class="text-right">VL Débito</th>
                <th class="text-right">VL Crédito</th>
                <th class="text-right">VL Final</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in dadosResumoCalculado" :key="idx">
                <td>{{ item.des_marca }}</td>
                <td class="text-right font-mono">{{ item.vl_base_comis | formatCurrency }}</td>
                <td class="text-right font-mono">{{ item.vl_acerto_debito | formatCurrency }}</td>
                <td class="text-right font-mono">{{ item.vl_acerto_credito | formatCurrency }}</td>
                <td class="text-right font-mono font-semibold">{{ item.vl_total_comis | formatCurrency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="content-card" v-if="dadosNotasFiscaisCalculado.length > 0">
        <div class="card-header">
          <h3 class="card-title">Notas Fiscais por Tipo</h3>
        </div>
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>Tipo de Nota</th>
                <th class="text-right">Valor Comissão</th>
                <th class="text-right">Valor IRRF</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in dadosNotasFiscaisCalculado" :key="idx">
                <td>{{ item.nota_comis }}</td>
                <td class="text-right font-mono">{{ item.vl_comis_nf | formatCurrency }}</td>
                <td class="text-right font-mono">{{ item.vl_ir_comis | formatCurrency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="drawer-overlay" :class="{ active: drawerOpen }" @click="closeDrawer"></div>
      <div class="filter-drawer" :class="{ open: drawerOpen }">
        <div class="drawer-header">
          <h3 class="drawer-title">Filtros</h3>
          <button class="drawer-close" @click="closeDrawer">
            <feather-icon icon="XIcon" size="20" />
          </button>
        </div>
        <div class="drawer-body">
          <div class="form-field" v-if="representantes.length > 1">
            <label class="field-label">Representante</label>
            <select v-model="filtros.cod_repres" class="field-input">
              <option :value="null">Todos os representantes</option>
              <option
                v-for="representante in representantes"
                :key="representante.representanteid"
                :value="representante.representanteid"
              >
                {{ representante.representanteid }} - {{ representante.representantenome }}
              </option>
            </select>
          </div>
          <div class="form-field">
            <label class="field-label">Mês</label>
            <select v-model="filtroMesAno.mes" class="field-input">
              <option v-for="m in mesesOptions" :key="m.value" :value="m.value">{{ m.text }}</option>
            </select>
          </div>
          <div class="form-field">
            <label class="field-label">Ano</label>
            <select v-model="filtroMesAno.ano" class="field-input">
              <option v-for="a in anosOptions" :key="a" :value="a">{{ a }}</option>
            </select>
          </div>
        </div>
        <div class="drawer-footer">
          <b-button block variant="primary" class="w-full" @click="aplicarFiltros">
            <feather-icon icon="CheckIcon" size="16" style="margin-right: 0.5rem;" />
            <span>Aplicar Filtros</span>
          </b-button>
          <b-button block variant="secondary" class="w-full" @click="limparFiltrosDrawer">
            <feather-icon icon="XIcon" size="16" style="margin-right: 0.5rem;" />
            <span>Limpar</span>
          </b-button>
        </div>
      </div>

    </b-overlay>
  </div>
</template>

<script>
import { BOverlay, BButton } from 'bootstrap-vue';
import moment from 'moment-timezone';
import { mapGetters, mapActions } from 'vuex';
import ComissoesService from '@/services/relatorios/comissoes.service';
import SLSRepresentanteService from '@/services/Cadastros/ApoioVendas/SLSRepresentante.service';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import ActionBar from '@/components/ActionBar.vue';

moment.tz.setDefault('America/Sao_Paulo');

const comissoesService = new ComissoesService();
const slsRepresentanteService = new SLSRepresentanteService();

export default {
  name: 'RelatorioComissoes',
  components: {
    BOverlay,
    BButton,
    ActionBar,
  },
  filters: {
    formatCurrency(value) {
      if (!value) return 'R$ 0,00';
      const numValue = parseFloat(value);
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(numValue);
    },
    formatDate(value) {
      if (!value) return '';
      return moment.utc(value).format('DD/MM/YYYY');
    },
  },
  data() {
    return {
      drawerOpen: false,
      isPaginating: false,
      representantes: [],
      pageOptions: [10, 20, 50, 100],
      filtros: {
        page: 1,
        perPage: 10,
        cod_repres: null,
        dt_emis: null,
      },
      filtroMesAno: {
        mes: moment().month() + 1,
        ano: moment().year(),
      },
      mesesOptions: [
        { value: 1, text: 'Janeiro' },
        { value: 2, text: 'Fevereiro' },
        { value: 3, text: 'Março' },
        { value: 4, text: 'Abril' },
        { value: 5, text: 'Maio' },
        { value: 6, text: 'Junho' },
        { value: 7, text: 'Julho' },
        { value: 8, text: 'Agosto' },
        { value: 9, text: 'Setembro' },
        { value: 10, text: 'Outubro' },
        { value: 11, text: 'Novembro' },
        { value: 12, text: 'Dezembro' },
      ],
      anosOptions: [],
      resumoList: [],
      nfEmissaoList: [],
    };
  },
  computed: {
    ...mapGetters('comissoesStore', {
      dadosComissoes: 'getDadosComissoes',
      loading: 'getLoading',
      meta: 'getMeta',
      allDadosComissoes: 'getAllDadosComissoes',
      loadingTotals: 'getLoadingTotals',
    }),
    totalVlNota() {
      return this.dadosComissoes.reduce((sum, item) => sum + parseFloat(item.vl_nota || 0), 0);
    },
    totalVlComissao() {
      return this.resumoList.reduce((sum, item) => sum + parseFloat(item.vl_total_comis || 0), 0);
    },
    activeFiltersCount() {
      return this.filtros.cod_repres ? 1 : 0;
    },
    hasActiveFilters() {
      return this.filtros.cod_repres || this.filtroMesAno.mes || this.filtroMesAno.ano;
    },
    filterChipsData() {
      const chips = [];
      if (this.filtros.cod_repres) {
        chips.push({ key: 'representante', label: `Rep: ${this.filtros.cod_repres}`, removable: true });
      }
      if (this.filtroMesAno.mes && this.filtroMesAno.ano) {
        chips.push({ key: 'mesano', label: `${this.getMesNome(this.filtroMesAno.mes)}/${this.filtroMesAno.ano}`, removable: false });
      }
      return chips;
    },
    dadosResumoCalculado() {
      return this.resumoList;
    },
    dadosNotasFiscaisCalculado() {
      return this.nfEmissaoList;
    },
  },
  methods: {
    ...mapActions('comissoesStore', [
      'setFilters',
      'clearFilters',
      'setLoading',
      'setAllDadosComissoes',
      'clearAllDadosComissoes',
      'setLoadingTotals',
    ]),
    openDrawer() {
      this.drawerOpen = true;
      document.body.style.overflow = 'hidden';
    },
    closeDrawer() {
      this.drawerOpen = false;
      document.body.style.overflow = '';
    },
    handleRemoveChip(chip) {
      if (chip.key === 'representante') {
        this.filtros.cod_repres = null;
      }
    },
    aplicarFiltros() {
      this.closeDrawer();
      this.pesquisar();
    },
    limparFiltrosDrawer() {
      this.filtros.cod_repres = null;
      this.filtroMesAno = { mes: moment().month() + 1, ano: moment().year() };
    },
    getMesNome(mes) {
      const m = this.mesesOptions.find((o) => o.value === mes);
      return m ? m.text.substring(0, 3) : '';
    },
    goToPage(page) {
      this.filtros.page = page;
      this.changePage();
    },
    async buscarPaginaAtual() {
      try {
        this.isPaginating = true;
        this.setLoading(true);
        const dataCompleta = moment()
          .year(this.filtroMesAno.ano)
          .month(this.filtroMesAno.mes - 1)
          .date(1)
          .format('YYYY-MM-DD');
        const filtrosLimpos = { ...this.filtros, dt_emis: dataCompleta };
        Object.keys(filtrosLimpos).forEach((key) => { if (filtrosLimpos[key] === null || filtrosLimpos[key] === '') delete filtrosLimpos[key]; });
        const response = await comissoesService.findAll(filtrosLimpos);
        this.$store.commit('comissoesStore/SET_DADOS_COMISSOES', response.data);
        this.resumoList = response.resumo || [];
        this.nfEmissaoList = response.nf_emissao || [];
        this.$store.commit('comissoesStore/SET_META', {
          page: response.page,
          perPage: response.perPage,
          pages: response.pages,
          total: response.total,
        });
      } catch (error) {
        console.error('Erro ao buscar página:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro', text: 'Falha ao carregar a página.', icon: 'AlertCircleIcon', variant: 'danger',
          },
        });
      } finally {
        this.setLoading(false);
        this.isPaginating = false;
      }
    },
    async pesquisar() {
      try {
        this.setLoading(true);
        this.filtros.page = 1;
        const dataCompleta = moment()
          .year(this.filtroMesAno.ano)
          .month(this.filtroMesAno.mes - 1)
          .date(1)
          .format('YYYY-MM-DD');
        const filtrosParaEnvio = { ...this.filtros, dt_emis: dataCompleta };
        const filtrosLimpos = { ...filtrosParaEnvio };
        Object.keys(filtrosLimpos).forEach((key) => { if (filtrosLimpos[key] === null || filtrosLimpos[key] === '') delete filtrosLimpos[key]; });
        const response = await comissoesService.findAll(filtrosLimpos);
        this.$store.commit('comissoesStore/SET_DADOS_COMISSOES', response.data);
        this.resumoList = response.resumo || [];
        this.nfEmissaoList = response.nf_emissao || [];
        const metaResp = {
          page: response.page,
          perPage: response.perPage,
          pages: response.pages,
          total: response.total,
        };
        this.$store.commit('comissoesStore/SET_META', metaResp);
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro', text: 'Erro ao buscar dados do relatório. Tente novamente.', icon: 'AlertCircleIcon', variant: 'danger',
          },
        });
      } finally {
        this.setLoading(false);
      }
    },
    limparFiltros() {
      this.filtros = {
        page: 1, perPage: 10, cod_repres: null, dt_emis: null,
      };
      this.filtroMesAno = { mes: moment().month() + 1, ano: moment().year() };
      this.resumoList = [];
      this.nfEmissaoList = [];
      this.clearFilters();
      this.clearAllDadosComissoes();
    },
    async changePage() {
      await this.buscarPaginaAtual();
    },
    async gerarRelatorioPDF() {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Gerando PDF',
          text: 'Aguarde...',
          icon: 'LoaderIcon',
          variant: 'info',
        },
      });
      try {
        this.setLoading(true);
        const dataCompleta = moment()
          .year(this.filtroMesAno.ano)
          .month(this.filtroMesAno.mes - 1)
          .date(1)
          .format('YYYY-MM-DD');
        const filtrosParaPdf = {
          cod_repres: this.filtros.cod_repres,
          dt_emis: dataCompleta,
          page: this.filtros.page,
          perPage: this.filtros.perPage,
        };
        const filtrosLimpos = { ...filtrosParaPdf };
        Object.keys(filtrosLimpos).forEach((key) => { if (filtrosLimpos[key] === null || filtrosLimpos[key] === '') delete filtrosLimpos[key]; });
        const response = await comissoesService.gerarPdfComissoes(filtrosLimpos);
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const dataAtual = moment().format('DD-MM-YYYY_HH-mm-ss');
        const nomeArquivo = `relatorio-comissoes_${this.filtroMesAno.mes}-${this.filtroMesAno.ano}_${dataAtual}.pdf`;
        link.download = nomeArquivo;
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'PDF Gerado',
            text: 'Relatório PDF gerado e baixado com sucesso!',
            icon: 'FileTextIcon',
            variant: 'success',
          },
        });
      } catch (error) {
        console.error('Erro ao gerar PDF:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Erro ao gerar o relatório PDF. Tente novamente.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.setLoading(false);
      }
    },
    async carregarRepresentantes() {
      try {
        const representantes = await slsRepresentanteService.listarRepresentanteInfoPedido({
          page: 1,
          perPage: 999999,
        });
        this.representantes = Array.isArray(representantes) ? representantes : [];
      } catch (error) {
        console.error('Erro ao carregar representantes do filtro:', error);
        this.representantes = [];
      }
    },
    gerarAnosOptions() {
      const anoAtual = moment().year();
      const anosDisponiveis = [];
      for (let i = anoAtual - 5; i <= anoAtual + 1; i++) {
        anosDisponiveis.push(i);
      }
      this.anosOptions = anosDisponiveis;
    },
    handleKeydown(e) {
      if (e.key === 'Escape' && this.drawerOpen) {
        this.closeDrawer();
      }
    },
  },
  created() {
    this.gerarAnosOptions();
    this.carregarRepresentantes();
    window.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown);
    document.body.style.overflow = '';
  },
};
</script>

<style scoped>
.comissoes-page {
  padding: 0.5rem 0.75rem;
  max-width: 100%;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.75rem;
  margin-bottom: 0.5rem;
}

.breadcrumb-link {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  color: var(--sf-surface-muted);
  text-decoration: none;
  transition: color 0.15s ease;
}

.breadcrumb-link:hover {
  color: var(--sf-accent);
}

.breadcrumb-separator {
  color: var(--sf-surface-muted);
}

.breadcrumb-current {
  color: var(--sf-surface-text-dark);
  font-weight: 500;
}

.action-bar-btn {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.625rem;
  font-size: 0.8125rem;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  height: 32px;
}

.primary-btn {
  background: var(--sf-btn-primary-bg);
  color: var(--sf-btn-primary-text, #fff);
  border: none;
}

.primary-btn:hover:not(:disabled) {
  background: var(--sf-btn-primary-hover, #5147d3);
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.25);
}

.primary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ghost-btn {
  background: transparent;
  color: var(--sf-surface-muted);
  border: 1px solid var(--sf-card-border);
}

.ghost-btn:hover {
  background: var(--sf-surface-bg);
  color: var(--sf-surface-text);
}

.secondary-btn {
  background: var(--sf-card-bg);
  border: 1px solid var(--sf-card-border);
  color: var(--sf-surface-text);
}

.secondary-btn:hover {
  background: var(--sf-surface-bg);
}

@media (max-width: 768px) {
  .btn-text {
    display: none;
  }
}

.filter-chips-old {
  display: flex;
  gap: 0.375rem;
  flex-wrap: wrap;
}

.filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.6875rem;
  background: var(--sf-card-bg);
  border: 1px solid var(--sf-card-border);
  border-radius: 4px;
  color: var(--sf-surface-muted);
}

.chip-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  padding: 0;
  font-size: 0.875rem;
  line-height: 1;
  background: transparent;
  border: none;
  color: var(--sf-surface-muted);
  cursor: pointer;
  border-radius: 50%;
}

.chip-close:hover {
  background: var(--sf-surface-bg);
  color: var(--sf-surface-text);
}

.kpi-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.kpi-card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: var(--sf-card-bg);
  border: 1px solid var(--sf-card-border);
  border-radius: 6px;
}

.kpi-card-highlight {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border-color: transparent;
}

.kpi-card-highlight .kpi-icon {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.kpi-card-highlight .kpi-value,
.kpi-card-highlight .kpi-label {
  color: #ffffff;
}

.kpi-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: rgba(99, 102, 241, 0.1);
  border-radius: 8px;
  color: #6366f1;
  flex-shrink: 0;
}

.kpi-content {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
}

.kpi-value {
  font-size: 1rem;
  font-weight: 600;
  color: var(--sf-surface-text-dark);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kpi-label {
  font-size: 0.6875rem;
  color: var(--sf-surface-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.content-card {
  background: var(--sf-card-bg);
  border: 1px solid var(--sf-card-border);
  border-radius: 6px;
  margin-bottom: 0.75rem;
  overflow: hidden;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.625rem 0.75rem;
  border-bottom: 1px solid var(--sf-card-border);
  background: var(--sf-surface-bg);
}

.card-title {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--sf-surface-text-dark);
  margin: 0;
}

.table-info {
  font-size: 0.6875rem;
}

.text-muted { color: var(--sf-surface-muted); }

.table-container {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.75rem;
}

.data-table th {
  padding: 0.5rem 0.75rem;
  text-align: left;
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--sf-surface-muted);
  background: var(--sf-surface-bg);
  border-bottom: 1px solid var(--sf-card-border);
  white-space: nowrap;
}

.data-table td {
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid var(--sf-card-border);
  color: var(--sf-surface-text);
}

.data-table tbody tr:hover {
  background: var(--sf-surface-bg);
}

.text-right {
  text-align: right;
}

.font-mono {
  font-family: ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Monaco, Consolas, monospace;
}

.font-semibold {
  font-weight: 600;
}

.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem;
  background: var(--sf-surface-bg);
  border-top: 1px solid var(--sf-card-border);
}

.per-page-control {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.per-page-label {
  font-size: 0.6875rem;
  color: var(--sf-surface-muted);
}

.per-page-select {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  border: 1px solid var(--sf-form-border);
  border-radius: 4px;
  background: var(--sf-form-bg);
  color: var(--sf-form-text);
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.page-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  background: var(--sf-card-bg);
  border: 1px solid var(--sf-card-border);
  border-radius: 4px;
  color: var(--sf-surface-text);
  cursor: pointer;
  transition: all 0.15s ease;
}

.page-btn:hover:not(:disabled) {
  background: var(--sf-surface-bg);
  border-color: var(--sf-accent);
  color: var(--sf-accent);
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 0.75rem;
  color: var(--sf-surface-muted);
  font-family: ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Monaco, Consolas, monospace;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
}

.empty-icon {
  color: var(--sf-surface-muted);
  margin-bottom: 1rem;
}

.empty-text {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--sf-surface-text-dark);
  margin: 0 0 0.25rem;
}

.empty-hint {
  font-size: 0.75rem;
  color: var(--sf-surface-muted);
  margin: 0;
}

.drawer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  z-index: 1040;
}

.drawer-overlay.active {
  opacity: 1;
  visibility: visible;
}

.filter-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 320px;
  max-width: 90vw;
  background: var(--sf-card-bg);
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  transform: translateX(100%);
  transition: transform 0.25s ease;
  z-index: 1050;
  display: flex;
  flex-direction: column;
}

.filter-drawer.open {
  transform: translateX(0);
}

.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--sf-card-border);
  flex-shrink: 0;
}

.drawer-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--sf-surface-text-dark);
  margin: 0;
}

.drawer-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: none;
  color: var(--sf-surface-muted);
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.15s ease;
}

.drawer-close:hover {
  background: var(--sf-surface-bg);
  color: var(--sf-surface-text);
}

.drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
}

.form-field {
  margin-bottom: 1rem;
}

.field-label {
  display: block;
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--sf-surface-muted);
  margin-bottom: 0.375rem;
}

.field-input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 0.8125rem;
  border: 1px solid var(--sf-form-border);
  border-radius: 5px;
  background: var(--sf-form-bg);
  color: var(--sf-form-text);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.field-input:focus {
  outline: none;
  border-color: var(--sf-accent);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.field-input:disabled,
.field-input[readonly] {
  background: var(--sf-surface-bg);
  cursor: not-allowed;
}

.drawer-footer {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  border-top: 1px solid var(--sf-card-border);
  flex-shrink: 0;
}

.w-full {
  width: 100%;
  justify-content: center;
}

@media (max-width: 768px) {
  .kpi-row {
    grid-template-columns: 1fr;
  }
}

/* Overrides específicos de dark removidos; as variáveis --sf-* cobrem ambos os temas */
</style>
